type CubeProps = {
  className?: string;
};
export const Cube = ({ className }: CubeProps) => (
  <svg className={className} viewBox="0 0 640 640" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M312.3 103.1C317.3 100.2 323.3 100.2 328.3 103.1L488.1 195.4L320.3 292.3L152.5 195.4L312.3 103.1zM128.5 237L296.3 333.9L296.3 527.7L136.5 435.4C131.5 432.5 128.5 427.3 128.5 421.5L128.5 236.9zM344.3 527.7L344.3 333.9L512.1 237L512.1 421.6C512.1 427.3 509.1 432.6 504.1 435.5L344.3 527.7zM352.3 61.6C332.5 50.2 308.1 50.2 288.3 61.6L112.5 163C92.7 174.4 80.5 195.6 80.5 218.4L80.5 421.4C80.5 444.3 92.7 465.4 112.5 476.8L288.3 578.5C308.1 589.9 332.5 589.9 352.3 578.5L528.2 477C548 465.6 560.2 444.4 560.2 421.6L560.2 218.6C560.2 195.7 548 174.6 528.2 163.2L352.3 61.5z"
      fill="currentColor"
    />
  </svg>
);
